// components/Molecules/HeaderBrand/HeaderBrand.js
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';

const HeaderBrand = ({ 
  logoSrc = '/img/fommeslogo-50.png',
  logoAlt = 'Site Logo',
  siteName = 'Fommes',
  homeUrl = '/',
  showSiteName = true,
  logoWidth = 50,
  logoHeight = 50
}) => (
  <div className="header-brand">
    <Link href={homeUrl} className="brand-link">
      <Image src={logoSrc} alt={logoAlt} width={logoWidth} height={logoHeight} priority />
      {showSiteName && <span className="brand-name">{siteName}</span>}
    </Link>
  </div>
);

HeaderBrand.propTypes = {
  logoSrc: PropTypes.string,
  logoAlt: PropTypes.string,
  siteName: PropTypes.string,
  homeUrl: PropTypes.string,
  showSiteName: PropTypes.bool,
  logoWidth: PropTypes.number,
  logoHeight: PropTypes.number,
};

export default HeaderBrand;